import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip, Typography } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import { DateTime } from 'luxon';

import { IStudentWorkingOffLessonModel } from '@common/models/StudentPrograms/StudentWorkingOffLesson';

import * as Styled from './styled';

interface PropsType {
	working_off_lesson: IStudentWorkingOffLessonModel;
}

function ProgramSectionCourseInfoWorkingOffLessonItem({ working_off_lesson }: PropsType) {
	const { t } = useTranslation();

	if (!working_off_lesson?.lesson_name) return null;

	const formattedDate = DateTime.fromFormat(
		working_off_lesson.schedule_lesson_start,
		'yyyy-MM-dd HH:mm:ss',
	).toFormat('dd.MM.yyyy');

	return (
		<Styled.Wrap elevation={2}>
			<Styled.SubWrap>
				<Styled.Image src={working_off_lesson.cover_url} alt="Lesson" />
				<MediaTypography
					variant="body1"
					variants={{ sm: 'body2' }}
					lineClamp={{ default: 1, sm: 3 }}
				>
					{working_off_lesson.lesson_name}
				</MediaTypography>
			</Styled.SubWrap>
			<Styled.SubWrap sx={{ justifyContent: 'space-between' }}>
				<Chip color="error" label={t('gradeBook.absent')} />
				<Typography>{formattedDate}</Typography>
			</Styled.SubWrap>
		</Styled.Wrap>
	);
}

export default ProgramSectionCourseInfoWorkingOffLessonItem;
